/* eslint-disable import/prefer-default-export */
import {css} from '@emotion/react'
import {IS_PROD, IS_DEV} from './env'

import AfterallSerifRegularWoff2 from './fonts/afterall-serif-regular-woff2.woff2'
import AfterallSerifRegularWoff from './fonts/afterall-serif-regular-woff.woff'
import ProximaNovaRegularWoff2 from './fonts/proximanova-regular-woff2.woff2'
import ProximaNovaRegularWoff from './fonts/proximanova-regular-woff.woff'
import ProximaNovaSemiBoldWoff2 from './fonts/proximanova-semibold-woff2.woff2'
import ProximaNovaSemiBoldWoff from './fonts/proximanova-semibold-woff.woff'
import ProximaNovaBoldWoff2 from './fonts/proximanova-bold-woff2.woff2'
import ProximaNovaBoldWoff from './fonts/proximanova-bold-woff.woff'
import DMSansRegularTtf from './fonts/DMSans-Light.ttf'
import DMSansSemiBoldTtf from './fonts/DMSans-SemiBold.ttf'
import AliceRegularTtf from './fonts/Alice-Regular.ttf'
import LoraMediumTtf from './fonts/Lora-Medium.ttf'
import InterRegularWoff2 from './fonts/Inter-400-latin.woff2'
import InterBoldWoff2 from './fonts/Inter-700-latin.woff2'

// social icon svgs
import facebookIcon from './images/social-icons/facebook.svg'
import linkedInIcon from './images/browser/social/linkedin.svg'
import instagramIcon from './images/social-icons/instagram.svg'
import redditIcon from './images/social-icons/reddit.svg'
import twitterIcon from './images/social-icons/twitter.svg'
import mastodonIcon from './images/social-icons/mastodon.svg'

// color names are taken from startpage design team's Figma names
export const colors = {
    black: `#0C0D0F`,
    black1New: `#0C0D0F`,
    brandBlue: `#6573FF`,
    brandBlueLight: `#A6AFFF`,
    brandBlueLight2: `#a3b1ff`,
    brandBlueLight3: `#8695fd`,
    brandBlueLight4: `#A7B1FC`,
    brandBlueUltraLight: `#F2F3FF`,
    brandBlueLightest: `#F7F7FF`,
    boxShadow: `2px 4px 8px rgba(0,0,0,.15)`,
    gold: `#FDB22B`,
    goldLight: `#FFF3D3`,
    midnight: `#202945`,
    midnightAlt: `#3B435B`,
    midnightLight: `#CED1DD`,
    midnightMedium: `#7F869F`,
    purple: `#BA6FD7`,
    purpleLight: `#F9E9FD`,
    purpleLightGradient: `linear-gradient(278.27deg, #F0F3FF 10.6%, #FCF3FF 86.98%)`,
    teal: `#29DDCC`,
    tealLight: `#DCF5EF`,
    tealLight2: `#51FFEE`,
    whisper: `#FBFBFD`,
    whisperDark: `#EBECF7`,
    whisperDarkest: `#DEE0F7`,
    whisperLight: `#FFFFFF`,
    whisperMedium: `#F2F3FF`,
}

export const globalStyles = css`
    @font-face {
        font-family: 'Inter';
        src: url(${InterRegularWoff2}) format('woff2');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'Inter';
        src: url(${InterBoldWoff2}) format('woff2');
        font-weight: 700;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'DM Sans';
        src: url(${DMSansRegularTtf}) format('truetype');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'Alice';
        src: url(${AliceRegularTtf}) format('truetype');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'Lora';
        src: url(${LoraMediumTtf}) format('truetype');
        font-weight: 500;
        font-style: normal;
    }

    @font-face {
        font-family: 'Afterall Serif';
        src: url(${AfterallSerifRegularWoff2}) format('woff2'), url(${AfterallSerifRegularWoff}) format('woff');
    }
    @font-face {
        font-family: 'Proxima Nova';
        src: url(${ProximaNovaRegularWoff2}) format('woff2'), url(${ProximaNovaRegularWoff}) format('woff');
    }

    @font-face {
        font-family: 'Proxima Nova SemiBold';
        src: url(${ProximaNovaSemiBoldWoff2}) format('woff2'), url(${ProximaNovaSemiBoldWoff}) format('woff');
    }

    @font-face {
        font-family: 'Proxima Nova Bold';
        src: url(${ProximaNovaBoldWoff2}) format('woff2'), url(${ProximaNovaBoldWoff}) format('woff');
    }

    html {
        box-sizing: border-box;
    }

    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    * {
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans,
            Droid Sans, Helvetica Neue, sans-serif;
        color: ${colors.black};
    }

    html,
    body,
    main,
    #___gatsby,
    #gatsby-focus-wrapper {
        height: 100%;
        margin: 0;
    }

    h1 {
        font-family: 'Inter', sans-serif;
        margin: 0;
    }

    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Inter', sans-serif;
        margin: 0;
    }

    h2 {
        font-size: 40px;
        font-weight: 600;
        letter-spacing: 0.33px;
    }

    a {
        text-decoration: none;
        color: #202945;
    }

    p {
        line-height: 1.6;
        margin: 0;
        color: #202945;
    }
`

export const globalStylesProtection = css`
    @font-face {
        font-family: 'DM Sans';
        src: url(${DMSansRegularTtf}) format('truetype');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'DM Sans';
        src: url(${DMSansSemiBoldTtf}) format('truetype');
        font-weight: 600;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'Alice';
        src: url(${AliceRegularTtf}) format('truetype');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'Inter';
        src: url(${InterRegularWoff2}) format('woff2');
        font-weight: 400;
        font-style: normal;
    }
    
    @font-face {
        font-family: 'Inter';
        src: url(${InterBoldWoff2}) format('woff2');
        font-weight: 700;
        font-style: normal;
    }

    html {
        box-sizing: border-box;
    }

    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    * {
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans,
            Droid Sans, Helvetica Neue, sans-serif;
        color: #3b425b;
    }

    html,
    body,
    main,
    #___gatsby,
    #gatsby-focus-wrapper {
        height: 100%;
        margin: 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
        margin: 0;
    }

    a {
        text-decoration: none;
        color: #3b425b;
    }

    p {
        line-height: 1.6;
        color: #3b425b;
    }
`

export const gethomeLink = (languageCode = `en`) => {
    return `https://www.startpage.com/${languageCode}`
}

export const socialIcons = [
    {
        url: `https://twitter.com/startpage`,
        icon: twitterIcon,
        label: `twitter`,
    },
    {
        url: `https://www.reddit.com/r/StartpageSearch/`,
        icon: redditIcon,
        label: `reddit`,
    },
    {
        url: `https://www.instagram.com/startpage/`,
        icon: instagramIcon,
        label: `instagram`,
    },
    {
        url: `https://www.facebook.com/startpagesearch/`,
        icon: facebookIcon,
        label: `facebook`,
    },
    {
        url: `https://mastodon.social/@StartpageSearch`,
        icon: mastodonIcon,
        label: `mastodon`,
    },
]

export const legacyExtensionFavicons = [
    {
        href: 'https://www.startpage.com/sp/cdn/favicons/favicon--light.ico',
        rel: 'shortcut icon',
        type: 'image/x-icon',
    },
    {
        href: 'https://www.startpage.com/sp/cdn/favicons/extension/sp_icon_16.png',
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
    },
    {
        href: 'https://www.startpage.com/sp/cdn/favicons/extension/sp_icon_48.png',
        rel: 'icon',
        type: 'image/png',
        sizes: '48x48',
    },
    {
        href: 'https://www.startpage.com/sp/cdn/favicons/extension/sp_icon_128.png',
        rel: 'icon',
        type: 'image/png',
        sizes: '148x148',
    },
]

export const ADVERTORIAL_BASE_URL = IS_PROD || IS_DEV ? `https://private.startpage.com` : ``

export const LOGGING_BASE_URL = IS_DEV ? `http://localhost:8080` : `https://www.startpage.com`
